import { useFormContext } from 'react-hook-form';

import {
  ControlledCheckbox,
  ControlledTextField
} from 'components/shared/ControlledFields';
import MultiStepForm from 'components/shared/MultiStepForm/MultiStepForm';
import i18n from 'config/i18n';
import { getLocale } from 'utils/date';

import { FIELD } from './constants';

const t = i18n.getFixedT(getLocale(), 'common');

const AutomaticRosteringFormContent = () => {
  const { control } = useFormContext();

  return (
    <>
      <MultiStepForm.Section title={t('automaticRostering.engine')}>
        <ControlledCheckbox
          control={control}
          name={FIELD.ENABLED}
          label={t('automaticRostering.enabled')}
        />
        <ControlledTextField
          control={control}
          type="password"
          name={FIELD.API_KEY}
          label={t('automaticRostering.apiKey')}
          helperText={t('automaticRostering.apiKeyHelp')}
          autoComplete="off"
        />
      </MultiStepForm.Section>
      <MultiStepForm.Section title={t('automaticRostering.planUnits')}>
        <ControlledCheckbox
          control={control}
          name={FIELD.DEFAULT_FOR_ALL_PLAN_UNITS}
          label={t('automaticRostering.defaultEnabledForAllPlanUnits')}
        />
      </MultiStepForm.Section>
    </>
  );
};

export default AutomaticRosteringFormContent;
